// CommentsBox `source` for lead (company) comments.
export const LEAD_COMMENT_SOURCE = 'company';
